import React, { Fragment } from "react";
import { dayFormat } from "../../../utils/date";
import { ProjectType } from "../../../utils/enums";
import moment from "moment";

export const ProjectInfo = ({
  type = ProjectType.Consultation,
  thematicAreaName = "",
  dateFrom = moment(),
  dateTo = moment(),
  modeName = "",
  onlyForLegalAge = false,
  isAuth = false,
  isVoted = false,
  availableVoteForms = 0,
  voteForms = 0,
  isParticipate = false,
  isOnlyOneOffice = false,
  officeName = "",
  hasOnlyPostAddressForm = false,
  countOfDistricts = 0,
  countOfProjects = 0,
  ...props
}) => (
  <div className="consultation-item__infos">
    {type === ProjectType.Consultation && (
      <div className="consultation-item__info">
        <div className="consultation-item__info-label">Kategoria:</div>
        <div className="consultation-item__info-value">{thematicAreaName}</div>
      </div>
    )}
    {type !== ProjectType.PublicBudget && (
      <Fragment>
        <div className="consultation-item__info">
          <div className="consultation-item__info-label">Czas trwania od: </div>
          <div className="consultation-item__info-value">{`${dayFormat(
            dateFrom
          )}`}</div>
          <div className="consultation-item__info-label"> do: </div>
          <div className="consultation-item__info-value">{`${dayFormat(
            dateTo
          )}`}</div>
        </div>
        <div className="consultation-item__info">
          <div className="consultation-item__info-label">Tryb:</div>
          <div className="consultation-item__info-value">{modeName}</div>
        </div>
        <div className="consultation-item__info">
          <div className="consultation-item__info-label">
            Tylko dla pełnoletnich:
          </div>
          <div className="consultation-item__info-value">
            {onlyForLegalAge ? "Tak" : "Nie"}
          </div>
        </div>
      </Fragment>
    )}
    {type === ProjectType.PublicBudget && (
      <div className="consultation-item__info">
        <div className="consultation-item__info-label">Głosowanie od: </div>
        <div className="consultation-item__info-value">{`${dayFormat(
          dateFrom
        )}`}</div>
        <div className="consultation-item__info-label"> do: </div>
        <div className="consultation-item__info-value">{`${dayFormat(
          dateTo
        )}`}</div>
      </div>
    )}
    {isAuth && (
      <Fragment>
        {type !== ProjectType.Consultation && (
          <div className="consultation-item__info">
            <div className="consultation-item__info-label">Oddany głos:</div>
            <div className="consultation-item__info-value">
              {isVoted ? "Tak" : "Nie"}
            </div>
          </div>
        )}
        {type === ProjectType.Consultation && (
          <Fragment>
            {availableVoteForms > 0 && (
              <div className="consultation-item__info">
                <div className="consultation-item__info-label">
                  Oddany głos:
                </div>
                <div className="consultation-item__info-value">
                  {isVoted ? "Tak" : "Nie"}{" "}
                  {` (${voteForms} z ${availableVoteForms})`}
                </div>
              </div>
            )}
            {!hasOnlyPostAddressForm && (
              <div className="consultation-item__info">
                <div className="consultation-item__info-label">
                  Udział w konsultacji:
                </div>
                <div className="consultation-item__info-value">
                  {isParticipate ? "Tak" : "Nie"}
                </div>
              </div>
            )}
          </Fragment>
        )}
      </Fragment>
    )}
    {type === ProjectType.PublicBudget && (
      <Fragment>
        <div className="consultation-item__info">
          <div className="consultation-item__info-label">Liczba obszarów:</div>
          <div className="consultation-item__info-value">
            {countOfDistricts}
          </div>
        </div>
        <div className="consultation-item__info">
          <div className="consultation-item__info-label">Liczba projektów:</div>
          <div className="consultation-item__info-value">{countOfProjects}</div>
        </div>
      </Fragment>
    )}
    {!isOnlyOneOffice && (
      <div className="consultation-item__info">
        <div className="consultation-item__info-label">Jednostka: </div>
        <div className="consultation-item__info-value">{officeName}</div>
      </div>
    )}
  </div>
);
